var path = 'public/app/plugins/datasource/vali/partials/annotations.editor.html';
var html = "<vali-annotations-query-editor expr=ctrl.annotation.expr max-lines=ctrl.annotation.maxLines instant=ctrl.annotation.instant on-change=ctrl.onQueryChange datasource=ctrl.datasource />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;